import Vue from "vue";
import Vuex from "vuex";
import startPageInfo from "./modules/startPageInfo";
import searchSuggestions from "./modules/searchSuggestions.js";
import searchResult from "./modules/searchResults.js";
import searchPrdSuggetions from "./modules/searchProductSuggetions.js";
import searchInsuSuggetions from "./modules/searchInsuSuggetions.js";
import searchLocationSuggetions from "./modules/searchLocationSuggestions.js";
import getStores from "./modules/getStores.js";
import anbieterFilter from "./modules/anbieterFilter.js";
import productByTerm from "./modules/productByTerm";
import productByID from "./modules/productByID";
import productByTag from "./modules/productByTag";
import VuexPersistence from 'vuex-persist'
import basketModule from "./modules/basket.js";
import walkerBasketModule from "./modules/walkerBasket.js";
import sessionModule from "./modules/session.js";
import slider from "./modules/slider.js";
import sliderEx from "./modules/sliderEx.js";

Vue.use(Vuex)

const storeKey = 'AnniLocalStorageKey'
const vuexLocalStorage = new VuexPersistence({
    key: storeKey,
    restoreState: (key) => {
        try{
            const item = JSON.parse(window.localStorage.getItem(key));
            const now = new Date();
            if(key == "AnniLocalStorageKey" && now.getTime() > item.sessionModule.expiry){
                item.sessionModule.sessionID = undefined;
            }

            // do not cache slider & startPageInfo in local storage
            delete item.slider;
            delete item.startPageInfo;
            
            return item;
        }
        catch {
            return {}
        }
    },
    saveState: (key, state) => {
        window.localStorage.setItem(key, JSON.stringify(state))
    } 
})

const plugins = [vuexLocalStorage.plugin]
const store = new Vuex.Store({
    modules: {
        startPageInfo,
        searchSuggestions,
        searchResult,
        searchPrdSuggetions,
        searchInsuSuggetions,
        searchLocationSuggetions,
        getStores,
        productByTerm,
        productByID,
        productByTag,
        basketModule,
        walkerBasketModule,
        sessionModule,
        slider,
        sliderEx,
        anbieterFilter,
      },
    plugins
})

export default store

function refreshStore(event){
    if(event.key === storeKey)
    {
        store.replaceState(JSON.parse(event.newValue))
    }
}
window.addEventListener('storage', refreshStore);


